var exports = {
  "container": "x43cbe9c2--b53634--container",
  "title": "x43cbe9c2--b53634--title",
  "socials": "x43cbe9c2--b53634--socials",
  "social": "x43cbe9c2--b53634--social",
  "tablet": "x43cbe9c2--b53634--tablet",
  "phone": "x43cbe9c2--b53634--phone",
};

module.exports = exports;
